import { Trans } from '@lingui/react/macro';
import { Skeleton } from '@repo/videa-components/src/index';
import { Badge } from '@repo/videa-components/src/ui/badge';

import type { TVisitSummary } from '../../../react-query/useVisitSummaries';
import type { MouthArea } from '../patientStrip/patientStripOdontogram/hooks';
import { useTreatmentsGroupedByStatus } from '../patientStrip/patientStripOdontogram/hooks';

import { TreatmentsCellTreatment } from './treatmentsCellTreatment';

export const TreatmentsCell = ({
  visitSummary,
  loading,
}: {
  visitSummary?: TVisitSummary;
  loading?: boolean;
}) => {
  const { scheduled_future, scheduled_today, unscheduled } =
    useTreatmentsGroupedByStatus(visitSummary);

  const hasScheduledToday = Object.keys(scheduled_today).length > 0;
  const hasScheduledFuture = Object.keys(scheduled_future).length > 0;
  const hasUnscheduled = Object.keys(unscheduled).length > 0;

  if (loading) {
    return (
      <>
        <Skeleton className="vai-h-6 vai-w-full" />
        <Skeleton className="vai-h-6 vai-w-full vai-mt-2" />
        <Skeleton className="vai-h-6 vai-w-full vai-mt-2" />
        <Skeleton className="vai-h-6 vai-w-full vai-mt-2" />
      </>
    );
  }

  return (
    <div className="vai-flex vai-flex-col vai-gap-1 vai-items-start">
      {hasScheduledToday && (
        <>
          <Badge className="vai-border-black vai-font-inter" variant="outline">
            <Trans>SCHEDULED TODAY</Trans>
          </Badge>
          {scheduled_today.map(({ mouthArea, treatments }) => (
            <TreatmentsCellTreatment
              key={mouthArea}
              affectedArea={mouthArea as MouthArea}
              treatments={treatments}
            />
          ))}
        </>
      )}
      {hasScheduledFuture && (
        <>
          <Badge className="vai-border-black vai-font-inter" variant="outline">
            <Trans>SCHEDULED FUTURE</Trans>
          </Badge>
          {scheduled_future.map(({ mouthArea, treatments }) => (
            <TreatmentsCellTreatment
              key={mouthArea}
              affectedArea={mouthArea as MouthArea}
              treatments={treatments}
            />
          ))}
        </>
      )}
      {hasUnscheduled && (
        <>
          <Badge className="vai-border-black vai-font-inter" variant="outline">
            <Trans>NOT SCHEDULED</Trans>
          </Badge>
          {unscheduled.map(({ mouthArea, treatments }) => (
            <TreatmentsCellTreatment
              key={mouthArea}
              affectedArea={mouthArea as MouthArea}
              treatments={treatments}
            />
          ))}
        </>
      )}
    </div>
  );
};
